<section class="content head">
  <div class="content-wrapper audit-list">
    <iaud-audit-nav-bar class="audit-list__nav-bar"></iaud-audit-nav-bar>
    <div class="audit-list__no-audits" *ngIf="!hasInitialAudits && !auditFilter">
      <div class="audit-list__no-audits--icon">
        +
      </div>
      <div class="audit-list__no-audits--text">
        <h1>No Audits</h1>
        <p>There are no audits</p>
        <p>Please add new Audit</p>
      </div>
      <button mat-raised-button
              class="audit-list__no-audits--add-button"
              [color]="'accent'"
              routerLink="/audit/add">
        + Add Audit
      </button>
    </div>

    <div *ngIf="hasInitialAudits || auditFilter">
      <div class="audit-list__header">
        <h1>All Audits list</h1>
        <span>You currently have {{auditTableData?.totalCount}} draft Audits you are working on.</span>
      </div>
      <div class="audit-list__actions">
        <mat-form-field class="audit-list__actions--search-input white">
          <input matInput
                 [formControl]="filterInput"
                 placeholder="Find Audit"/>
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button mat-raised-button class="inverted" [color]="'none'" (click)="showFilterDlg()" *ngIf="!auditFilter"> + Show Filters</button>
        <button mat-raised-button [color]="'none'" (click)="showFilterDlg()" *ngIf="auditFilter"> &#x02713; Edit Filters</button>
        <button mat-raised-button
                class="inverted audit-list__actions--export-button"
                (click)="exportXls()">
          Export
        </button>
        <button mat-raised-button
                class="audit-list__actions--add-button"
                [color]="'accent'"
                routerLink="/audit/add">
          + Add Audit
        </button>
      </div>
    </div>
  </div>
</section>
<section class="content" *ngIf="(hasInitialAudits || auditFilter) && auditTableData">
  <div class="content-wrapper">
    <iaud-table [data]="auditTableData"
                [options]="auditTableOptions"
                [forceReloadEvent]="forceReloadEvent"
                [dataRefreshCallback]="reloadAuditList.bind(this)"
                [dataDeleteCallback]="deleteData.bind(this)"
                [deleteTitle]="'Delete Audit'"
                [deleteText]="'Are you sure you want to delete ${data.auditTitle} audit?'">
    </iaud-table>
  </div>
</section>

<ng-template #findingsCellTemplate let-rowData="rowData">
  <div class="finding-cell">
    <span class="text">
      {{rowData.numberOfFindings}}
    </span>
    <div class="button" [routerLink]="'/audit/' + rowData.id + '/finding/add'" *ngIf="rowData.status===auditStatus.DRAFT">+</div>
  </div>
</ng-template>

<ng-template #statusCellTemplate let-rowData="rowData">
  <iaud-audit-capa-status [status]="rowData.capaActivityStatus"></iaud-audit-capa-status>
</ng-template>

<ng-template #SMEsDetailTemplate let-detailData="detailData" let-detailOption="detailOption">
  <label [for]="detailOption.fieldName">{{detailOption.title}}</label>
  <p [id]="detailOption.fieldName" *ngFor="let sme of detailData.item[detailOption.fieldName]">
    {{ sme.fullName }}
  </p>
</ng-template>
